import React from 'react'
import { Accordion, Row } from 'react-bootstrap'
import FaqAccordion from '../../accordions/FaqAccordion/FaqAccordion'
import ContentContainer from '../../content/ContentContainer/ContentContainer'
import ContentCover from '../../content/ContentCover/ContentCover'
import SectionHeading from '../../section-heading/SectionHeading'

const FaqSection = ({ title, faqs }) => {
  const bg = {
    backgroundColor: 'rgba(55,86,147,0.1)',
  }

  return (
    <ContentCover bg={bg}>
      <ContentContainer>
        <SectionHeading title="FAQ's" center />
        <Accordion>
          <SectionHeading title={title} />
          {faqs.map((faq, index) => {
            return <FaqAccordion key={index} faq={faq} index={index} />
          })}
        </Accordion>
      </ContentContainer>
    </ContentCover>
  )
}

export default FaqSection
